import ZlbConfirm from '@/components/ZlbConfirm';
import { reqBasicInfo, updateBasicInfo } from '../services';

const responseErrorHandle = res => {
  const { success, message, statusText } = res;
  if (!success) {
    ZlbConfirm({
      title: message || statusText,
      showOkBtn: false,
      cancelText: '知道了',
    });
  }
  return success;
};

export default {
  namespace: 'unitManage',
  state: {
    basicInfo: {},
  },
  effects: {
    *basicInfo({ payload }, { call, put }) {
      const res = yield call(reqBasicInfo, payload);
      responseErrorHandle(res);
      yield put({
        type: 'update',
        payload: {
          basicInfo: res.result || {},
        },
      });
    },
    *updateBasicInfo({ payload }, { call, put }) {
      const res = yield call(updateBasicInfo, payload);
      return res;
    },
  },
  reducers: {
    update(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};
